<template>

    <v-container fluid>
    <v-row>
        <v-col>
 <div class="base-timer">
    <svg
      class="base-timer__svg"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g class="base-timer__circle">
        <circle
          class="base-timer__path-elapsed"
          cx="50"
          cy="50"
          r="46.5"
        />
        <path
        :stroke-dasharray="circleDasharray"
        :class="remainingPathColor"
          class="base-timer__path-remaining"
          d="
            M 50, 50
            m -45, 0
            a 45,45 0 1,0 90,0
            a 45,45 0 1,0 -90,0
          "></path>
      </g>
    </svg>
    <span class="base-timer__label">
      {{ formattedTimeLeft }}
    </span>
  </div>
        </v-col>
    </v-row>
   
 <v-row>
     <v-col cols="12" md="4" sm="4"> <h3>Set Time:</h3></v-col>
     <v-col cols="12" md="4" sm="4">
<v-text-field
label="min"
type="number"
min="0"
v-model="timeLimitMinutes"></v-text-field>
   </v-col>
  <v-col cols="12" md="4" sm="4">
<v-text-field
label="sec"
type="number"
min="0"
v-model="timeLimitSeconds"></v-text-field>
     </v-col>
     </v-row>
 <v-row>
       <v-spacer />
     <v-col cols="12" md="3" sm="3" >
         <v-btn small @click="setTimeLimit('1min')">1 min</v-btn>
     </v-col>
     <v-col cols="12" md="3" sm="3" >
         <v-btn small @click="setTimeLimit('2min')">2 min</v-btn>
     </v-col>
     <v-col cols="12" md="3" sm="3" >
          <v-btn small @click="setTimeLimit('5min')">5 min</v-btn>
     </v-col>
     <v-col cols="12" md="3" sm="3" >
          <v-btn small @click="setTimeLimit('10min')">10 min</v-btn>
         
     </v-col>
     <v-spacer />
 </v-row>
 <v-row>
     <v-col>
<v-row>
    <v-col cols="12" md="3" sm="3" class="mx-1">
<v-btn @click="startTimer()"> Start</v-btn>
</v-col>
<v-col cols="12" md="3" sm="3" class="mx-1">
<v-btn @click="resetTimer()"> Reset</v-btn>
</v-col>
<v-col cols="12" md="3" sm="3" class="mx-1">
<v-btn @click="pauseTimer()"> Stop</v-btn>
</v-col>
  </v-row>
     </v-col>
 </v-row>
 </v-container>
 
</template>
<script>
export default {
    data: () => ({
        timeLimitMinutes:null,
        timeLimitSeconds:null,
       
        timePassed:0,
        timerInterval: null,
        

        
    }),
    
    computed: {
        alertThreshold(){
return Math.floor( this.timeLimit*0.15) 
        },
        warningThreshold(){
return Math.floor( this.timeLimit*0.30) 
        },

        timeLimit(){
            
            return this.timeLimitMinutes*60 + this.timeLimitSeconds*1
        },
        timeLeft(){
           
return this.timeLimit - this.timePassed

        },
    formattedTimeLeft() {
      const timeLeft = this.timeLeft
      // The largest round integer less than or equal 
       //  to the result of time divided being by 60.
      const minutes = Math.floor(timeLeft / 60)
      // Seconds are the remainder of the time divided
      //   by 60 (modulus operator)
      let seconds = timeLeft % 60
      // If the value of seconds is less than 10,
      //   then display seconds with a leading zero
      if (seconds < 10) {
        seconds = `0${seconds}`
      }
      // The output in MM:SS format
      return `${minutes}:${seconds}`
    },
    // Update the dasharray value as time passes, starting with 283
    circleDasharray() {
        const FULL_DASH_ARRAY = 283
      return `${(this.timeFraction * FULL_DASH_ARRAY).toFixed(0)} 283`;
    },
    timeFraction() {
      // Divides time left by the defined time limit.      
      const rawTimeFraction = this.timeLeft / this.timeLimit
      
      return rawTimeFraction -
        (1 / this.timeLimit) * (1 - rawTimeFraction)
    
    },
    colorCodes() {
      return {
        info: {
          color: "green"
        },
        warning: {
          color: "orange",
          threshold: this.warningThreshold
        },
        alert: {
          color: "red",
          threshold: this.alertThreshold
        }
      }
    },
    remainingPathColor() {
       const { alert, warning, info } = this.colorCodes;
       if (this.timeLeft <= alert.threshold) {
         return alert.color;
       } else if (this.timeLeft <= warning.threshold) {
         return warning.color;
       } else {
         return info.color;
       }
    }
  },
  methods: {
    startTimer() {
        
      this.timerInterval = setInterval(() => { 
        if (this.timePassed == this.timeLimit)
        clearInterval(this.timerInterval)
        else
        this.timePassed += 1
        }, 1000)
    },
    resetTimer() {
        this.timePassed=0
     
    },
    pauseTimer() {
      clearInterval(this.timerInterval);
    },
    setTimeLimit(duration) {
if (duration==='1min')
{
    this.timeLimitMinutes = 1
    this.timeLimitSeconds = 0
}else if (duration==='2min')
{
    this.timeLimitMinutes = 2
    this.timeLimitSeconds = 0
}else if (duration==='5min')
{
    this.timeLimitMinutes = 5
    this.timeLimitSeconds = 0
}else 
{
    this.timeLimitMinutes = 10
    this.timeLimitSeconds = 0
} 
    }
  },
}
</script>
<style scoped lang="scss">

/* Sets the containers height and width */
.base-timer {
    &__path-remaining {
    stroke-width: 7px;
    stroke-linecap: round;
    transform: rotate(90deg);
    transform-origin: center;
    transition: 1s linear all;
    fill-rule: nonzero;
    stroke: currentColor;
    &.green {
      color: rgb(65, 184, 131);
    }
    &.orange {
      color: orange;
    }
    &.red {
      color: red;
    }
  }
  &__svg {
    /* Flips the svg and makes the animation to move left-to-right*/
    transform: scaleX(-1);
  }
    &__label {
    position: absolute;    
    
    /* Size should match the parent container */    
    width: 300px;
    height: 300px;
    /* Keep the label aligned to the top */    
    top: 0;
    /* Create a flexible box that centers content vertically and horizontally */    
    display: flex;
    align-items: center;
    justify-content: center;
    /* Sort of an arbitrary number; adjust to your liking */
    font-size: 48px;
  }
  position: relative;
  width: 300px;
  height: 300px;
/* Removes SVG styling that would hide the time label */
  &__circle {
    fill: none;
    stroke: none;
  }
/* The SVG path that displays the timer's progress */
  &__path-elapsed {
    stroke-width: 7px;
    stroke:grey;
  }
}
</style>